import { useNullableContext } from '~/common/contexts/nullableContext';
import { WorkflowSessionContext } from '../../WorkflowSessionContext';

export const useWorkflowSession = () =>
  useNullableContext(
    WorkflowSessionContext,
    'useWorkflowSession must be used within a WorkflowSessionContext.Provider',
  );
